import React from 'react';
import { Page } from '../../components';

export const MyNotification = ({ navigation }: any) => {
  return <Page title={'Notification'} />;
};
